import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=2973b92c&scoped=true"
import script from "./UserForm.vue?vue&type=script&lang=js"
export * from "./UserForm.vue?vue&type=script&lang=js"
import style0 from "./UserForm.vue?vue&type=style&index=0&id=2973b92c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2973b92c",
  null
  
)

export default component.exports